<section class="main-content wrapper content-padding " style="margin-top: 50px;">
  <div class="content-panel">
    <div class="tabs">
      <label class="tab">
        <a class="tab-link active-tab">Elenco delle priorità dei partner</a>
      </label>
    </div>

    <div class="item nowrap">
      <span class="btn-container top-button-container">

        <button class="btn btn-white vertical full-width-btn align-items-center" routerLink="nuovo">
          Aggiungi<i class="ml-10 fas fa-plus"></i>
        </button>

      </span>
    </div>

    <hr class="gold-hr">

    <section class="main-content wrapper scroll-delivery">
      <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage" (load)="navigate($event)"></app-pagination>

        <div class="custom-data-output has-margin-top" role="table" id="elencoConsegnePartner">
        <form class="table-row-container row first-row filter" [formGroup]="priorityLsitFilterForm" *ngIf="priorityLsitFilterForm" (ngSubmit)="filter()">
            <div class="item data-col-10 hideOnPhoneView">
                <h4 class="title" (click)="navigateOrder('PartnerPriority.id')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('PartnerPriority.id')"></i>
                  ID
                </h4>
                <span class="data">
                  <input type="number" min="1000" max="10000" formController="PartnerPriority.id">
                </span>
            </div>
      
            <div class="item data-col-20 hideOnPhoneView">
                <h4 class="title" (click)="navigateOrder('Provinces.provinceCode')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('Provinces.provinceCode')"></i>
                  Provincia
                </h4>
                <span class="data">
                  <input type="text" formControlName="Provinces.provinceCode" class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
                </span>
            </div>

            <div class="item data-col-20 hideOnPhoneView">
              <h4 class="title" (click)="navigateOrder('ProductCategory.categoryName')">
                <i class="sort-icon fas" [ngClass]="orderIcon('ProductCategory.categoryName')"></i>
                Categoria Prodotto
              </h4>
              <span class="data">
                <input type="text" formControlName="ProductCategory.categoryName" class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
              </span>
            </div>

            <div class="item data-col-20 hideOnPhoneView">
              <h4 class="title" (click)="navigateOrder('Partner.businessName')">
                <i class="sort-icon fas" [ngClass]="orderIcon('Partner.businessName')"></i>
                Partner
              </h4>
              <span class="data">
                <input type="text" formControlName="Partner.businessName" class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
              </span>
            </div>

            <div class="item nowrap">
              <h4 class="title hide-on-mobile">AZIONI</h4>
              <span class="data-row-left btn-container">
                <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
                  RICERCA <i class="fas fa-search"></i></button>
                  <br/>
                <button class="btn vertical align-items-center" (click)="$event.preventDefault(); resetFilter()">
                  RESET <i class="fas fa-times-circle"></i></button>
              </span>
            </div>
        </form>

        <div class="table-row-container row" *ngFor="let priority of partnerPriorityLists">

            <div class="item data-col-10">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  ID
                </h4>
                <div class="data data-id">
                  <div>{{ priority?.id || "---" }}</div>
                </div>
            </div>

            <div class="item data-col-10">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  Province
                </h4>
                <div class="data">
                  <div>
                    <span>
                      <b>{{ priority?.province?.provinceCode }}</b>
                      {{ priority?.province?.province }}
                    </span>
                  </div>
                </div>
            </div>
        
            <div class="item data-col-10">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  Product Category
                </h4>
                <div class="data">
                  <div>{{ priority?.productCategory?.categoryName || "---" }}</div>
                </div>
            </div>

            <div class="item data-col-10">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  Partners
                </h4>
                <div class="data">
                  <div *ngIf="priority?.partnerPriorities.length > 0">
                    <div *ngFor="let data of priority?.partnerPriorities; let last=last;">
                      {{ data?.partner?.businessName }}
                      <ng-container *ngIf="!last">, </ng-container>
                    </div>
                  </div>
                  <div *ngIf="priority?.partnerPriorities.length === 0">
                    ---
                  </div>
                </div>
            </div>

            <div class="item nowrap">
              <span class="data-row-left btn-container">
                <button class="btn vertical align-items-center" [routerLink]="['/partner/priority/list', priority?.id, 'edit']">
                  Modifica
                </button>
                <button class="btn btn-red vertical align-items-center" (click)="$event.preventDefault(); deletePartnerPriorityList(priority?.id)">
                  Elimina<i class="ml-10 far fa-trash-alt"></i>
                </button>
              </span>
            </div>
        </div>
      </div>
    </section>
  </div>
</section>

<!--
<section class="title-bar content-padding first-item ">
  <div class="wrapper nowrap">
    <h2 class="title-heading">Partner Priority List</h2>
    <div class="item nowrap">
      <span class="data-row-left btn-container top-button-container">
        <button class="btn btn-white vertical align-items-center" routerLink="nuovo">
          Aggiungi<i class="ml-10 fas fa-plus"></i>
        </button>
      </span>
    </div>
  </div>
</section>

<section class="main-content wrapper content-padding">
    <app-pagination [limit]="limit" [page]="page" [count]="count" [maxPage]="maxPage"></app-pagination>
    <div class="custom-data-output has-margin-top" role="table" id="elencoConsegnePartner">
        <form class="table-row-container row first-row filter" [formGroup]="priorityLsitFilterForm" *ngIf="priorityLsitFilterForm" (ngSubmit)="filter()">
            <div class="item data-col-10 hideOnPhoneView">
                <h4 class="title" (click)="navigateOrder('PartnerPriority.id')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('PartnerPriority.id')"></i>
                  ID
                </h4>
                <span class="data">
                  <input type="number" min="1000" max="10000" formController="PartnerPriority.id">
                </span>
            </div>
      
            <div class="item data-col-20 hideOnPhoneView">
                <h4 class="title" (click)="navigateOrder('Provinces.provinceCode')">
                  <i class="sort-icon fas" [ngClass]="orderIcon('Provinces.provinceCode')"></i>
                  Provincia
                </h4>
                <span class="data">
                  <input type="text" formControlName="Provinces.provinceCode" class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
                </span>
            </div>

            <div class="item data-col-20 hideOnPhoneView">
              <h4 class="title" (click)="navigateOrder('ProductCategory.categoryName')">
                <i class="sort-icon fas" [ngClass]="orderIcon('ProductCategory.categoryName')"></i>
                Categoria Prodotto
              </h4>
              <span class="data">
                <input type="text" formControlName="ProductCategory.categoryName" class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
              </span>
            </div>

            <div class="item data-col-20 hideOnPhoneView">
              <h4 class="title" (click)="navigateOrder('Partner.businessName')">
                <i class="sort-icon fas" [ngClass]="orderIcon('Partner.businessName')"></i>
                Partner
              </h4>
              <span class="data">
                <input type="text" formControlName="Partner.businessName" class="block w-full mt-1 text-sm dark:border-gray-600 dark:bg-gray-700 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 dark:focus:shadow-outline-gray form-input">
              </span>
            </div>

            <div class="item nowrap">
              <h4 class="title hide-on-mobile">AZIONI</h4>
              <span class="data-row-left btn-container">
                <button class="btn vertical align-items-center" (click)="$event.preventDefault(); filter()">
                  RICERCA <i class="fas fa-search"></i></button>
                  <br/>
                <button class="btn vertical align-items-center" (click)="$event.preventDefault(); resetFilter()">
                  RESET <i class="fas fa-times-circle"></i></button>
              </span>
            </div>
        </form>

        <div class="table-row-container row" *ngFor="let priority of partnerPriorityLists">

            <div class="item data-col-10">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  ID
                </h4>
                <div class="data data-id">
                  <div>{{ priority?.id || "---" }}</div>
                </div>
            </div>

            <div class="item data-col-10">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  Province
                </h4>
                <div class="data">
                  <div>
                    <span>
                      <b>{{ priority?.province?.provinceCode }}</b>
                      {{ priority?.province?.province }}
                    </span>
                  </div>
                </div>
            </div>
        
            <div class="item data-col-10">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  Product Category
                </h4>
                <div class="data">
                  <div>{{ priority?.productCategory?.categoryName || "---" }}</div>
                </div>
            </div>

            <div class="item data-col-10">
                <h4 class="title">
                  <i class="sort-icon fas"></i>
                  Partners
                </h4>
                <div class="data">
                  <div *ngIf="priority?.partnerPriorities.length > 0">
                    <div *ngFor="let data of priority?.partnerPriorities; let last=last;">
                      {{ data?.partner?.businessName }}
                      <ng-container *ngIf="!last">, </ng-container>
                    </div>
                  </div>
                  <div *ngIf="priority?.partnerPriorities.length === 0">
                    ---
                  </div>
                </div>
            </div>

            <div class="item nowrap">
              <span class="data-row-left btn-container">
                <button class="btn vertical align-items-center" [routerLink]="['/partner/priority/list', priority?.id, 'edit']">
                  Modifica
                </button>
                <button class="btn btn-red vertical align-items-center" (click)="$event.preventDefault(); deletePartnerPriorityList(priority?.id)">
                  Elimina<i class="ml-10 far fa-trash-alt"></i>
                </button>
              </span>
            </div>
          </div>
    </div>
</section>
-->